export const AdminDashboard = () => {
	return (<div></div>);
}